import Livesearch from 'adeliom-livesearch-js';
import AcfHelper from "../_acf";

let livesearch;

const Filters = {};

const formSelector = `js-livesearch-form`;
const pathAjax = `js-path-ajax`;
const actionAjax = `js-action-ajax`;
const perPage = `js-per-page`;

Filters.getInstance = () => {
    return livesearch;
};

Filters.init = (block) => {

    AcfHelper.handleInit(block, () => {

        const form = document.querySelector(`[${formSelector}]`);
        
        if (form) {
            livesearch = new Livesearch({
                pathAjax: form.getAttribute(pathAjax),
                actionAjax: form.getAttribute(actionAjax),
                perPage: form.getAttribute(perPage),
                minimumTimeLoading: 500,
                useAnimate: false,
                pageKey: 'pagination',
            });

            livesearch.init();
        }
    });
};
export { livesearch };
export default Filters;
